import { useState } from 'react';
import { FormControl, FormLabel, Stack } from '@chakra-ui/react';
import { Field } from 'formik';
import FormikInput from 'components/forms/new/formikFormFields/NameField';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';
import walkthroughIds from '../walkthroughIds';

const NameField = ({ errors, touched, darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!errors.name && touched.name}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    Name <span style={{ color: '#e53e3e' }}>*</span>
                </FormLabel>
                <Field
                    as={FormikInput}
                    id="name"
                    name="name"
                    placeholder="e.g. BT, AT&T, SoftBank"
                    maxLength={100}
                    data-walkthroughid={walkthroughIds.createMode.ufNameInput}
                    error={errors.name}
                />
                {isHovered && (
                    <FieldToolTip
                        label="Enter the service provider name."
                        ariaLabel="service-provider-name-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default NameField;
